import FacilityInfo from "@/views/reporting/LiquidHazardousWaste/FacilityInfo.vue";
import Materials from "@/views/reporting/LiquidHazardousWaste/Materials.vue";

export default {
    FacilityInfo,
    Materials
}